import './App.css';
import Footer from './components/Footer';
import Header from './components/Header'
import Main from "./components/Main";
import { Routes,Route } from "react-router-dom";
import Home from './components/Home';
import MoreProjects from './components/MoreProjects';
// import MoreProjects from './components/S';
function App() {
  return (
		<>
		<Routes>
			<Route path='/' element={<Home/>}/>
			<Route path='*' element={<Home/>}/>
		</Routes>
		</>
	);
}

export default App;
